import React, { useCallback } from 'react'

import { Div } from '@driftt/tide-core'

import { IQueryConfig } from 'api/report/query/types'
import ChartContainer from 'components/core/ChartContainer'
import ExportButton from 'components/core/ExportButton'

import LineGraph from './graph'

interface ILineChartProps {
  renderAdditionalContent?: () => any
  queryConfig: IQueryConfig
  onGraphPointClick?: (queryConfig: IQueryConfig) => void
  [key: string]: any
}

const LineChart = ({
  cumulative = false,
  currentSeries,
  currentSeriesLabel,
  loading,
  error,
  prevSeries,
  prevSeriesLabel,
  queryConfig,
  title,
  subtitle,
  tooltip,
  tooltipFlow,
  inlineCountChart,
  onExportClick,
  renderAdditionalContent,
  onGraphPointClick,
  invertDelta = false,
  isExportPending = false,
}: ILineChartProps) => {
  const renderData = () => {
    const onClick = onGraphPointClick
      ? (date: string) => {
          onGraphPointClick({ ...queryConfig, startDate: date, endDate: date })
        }
      : undefined
    return (
      <LineGraph
        currentSeries={currentSeries}
        currentSeriesLabel={currentSeriesLabel}
        prevSeries={prevSeries}
        prevSeriesLabel={prevSeriesLabel}
        queryConfig={queryConfig}
        invertDelta={invertDelta}
        onClick={onClick}
      />
    )
  }

  const renderAdditionalContentAndExportButtton = useCallback(
    () => (
      <Div className="chart-additional-content-actions">
        {renderAdditionalContent && renderAdditionalContent()}
        {onExportClick && (
          <ExportButton
            onClick={onExportClick}
            queryConfig={queryConfig}
            isExportPending={isExportPending}
          />
        )}
      </Div>
    ),
    [onExportClick, queryConfig, isExportPending, renderAdditionalContent]
  )

  const renderChartAdditionalContent =
    (onExportClick || renderAdditionalContent) &&
    renderAdditionalContentAndExportButtton

  return (
    <ChartContainer
      data={currentSeries}
      error={error}
      loading={loading}
      renderData={renderData}
      subtitle={subtitle && currentSeriesLabel}
      inlineCountChart={inlineCountChart}
      cumulative={cumulative}
      title={title}
      tooltip={tooltip}
      tooltipFlow={tooltipFlow}
      renderAdditionalContent={renderChartAdditionalContent}
    />
  )
}

export default LineChart
